<full-calendar #calendar
               [options]="calendarOptions">
</full-calendar>
